
export const keywordStyle = theme => ({
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: '100%',
    },
    contentAll: {
        [theme.breakpoints.up('sm')]: {
            height: 'calc(100vh - 64px)'
        },
        overflow: 'auto'
    },
    actionContainer: {
        flex: 1,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        padding: '0px 62px'
    }
})